import { call, put } from 'typed-redux-saga'
import { api as signalRApi } from '../../../../../api/signalRApi'
import {
	CONSUMER_SESSION_ACTIONS,
	ReopenConsumerSessionAction,
	reopenConsumerSessionFailed,
	reopenConsumerSessionSucceeded,
} from '../../actions/consumerDataPullSessionActions/consumerSessionDataActions'
import {
	StartCloseConsumerDataPullSessionAction,
	closeConsumerDataPullSessionFailed,
} from '../../actions/consumerDataPullSessionActions/closeConsumerDataPullSessionActions'
import {
	reopenConsumerDataPullSessionFailed,
	reopenConsumerDataPullSessionSucceeded,
} from '../../actions/consumerDataPullSessionActions/fetchBankSessionsTransactions'
import { transactionApiClient } from '../../../../../api/transactionApiClient'
import { authenticateWithSessionId } from '../../actions/consumerDataPullSessionActions/consumerAuthenticationActions'

export function* reopenConsumeSessionSaga(
	action: ReopenConsumerSessionAction,
): Generator {
	try {
		// TODO: Remove duplicates when separate-accounts-transactions is true
		yield* call(transactionApiClient.reopenConsumerDataPullSession)
		yield put(reopenConsumerDataPullSessionSucceeded())
		yield put(reopenConsumerSessionSucceeded())
		if (action.payload.sessionId) {
			yield put(authenticateWithSessionId(action.payload.sessionId))
		}
	} catch (error: any) {
		yield put(reopenConsumerSessionFailed(error))
		yield put(reopenConsumerDataPullSessionFailed(error))
	}
}

export function* closeConsumerDataPullSessionSaga(
	action: StartCloseConsumerDataPullSessionAction,
): Generator {
	try {
		yield* call(() =>
			signalRApi.closeConsumerDataPullSession(
				action.payload.shouldClearBudgetAndDebtData,
			),
		)
	} catch (error: any) {
		yield put(closeConsumerDataPullSessionFailed(error))
	}
}

reopenConsumeSessionSaga.pattern = CONSUMER_SESSION_ACTIONS.REOPEN_SESSION
